<template>
  <b-badge :class="classModifier" variant="none">{{
    $t(`campaign.status.${status}`)
  }}</b-badge>
</template>

<script>
export default {
   name: "CampaignStatusBadge",
   props: {
     status: String
   },
   computed: {
     classModifier(){
       switch (this.status) {
         case 'DRAFT':
           return 'border border-secondary text-secondary badge-pill'
         case 'TO_SEND':
           return 'border border-info text-info badge-pill'
         case 'SENDING':
           return 'border border-warning text-warning badge-pill'
         case 'SENT':
           return 'border border-success text-success badge-pill'
         case 'ERROR':
           return 'border border-danger text-danger badge-pill'
         default:
           return 'outline-danger'
       }
     }
   }
}
</script>

<style>
</style>